module.exports = __webpack_public_path__ + "a90c87bf6efcd7fa0df5457503230995.fbx";